import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b02b94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "service-location" }
const _hoisted_2 = { class: "service-location__header" }
const _hoisted_3 = { class: "service-location__content" }
const _hoisted_4 = {
  key: 0,
  class: "service-location__comment"
}
const _hoisted_5 = { class: "service-location__expandable" }
const _hoisted_6 = {
  key: 0,
  class: "service-location__access-transport-wrapper"
}
const _hoisted_7 = {
  key: 0,
  class: "service-location__access-section"
}
const _hoisted_8 = { class: "body-2-semi" }
const _hoisted_9 = { class: "service-location__access-list" }
const _hoisted_10 = {
  key: 1,
  class: "service-location__public-transport-section"
}
const _hoisted_11 = { class: "body-2-semi" }
const _hoisted_12 = { class: "service-location__public-transport-list" }
const _hoisted_13 = { class: "service-location__map" }
const _hoisted_14 = {
  key: 2,
  class: "service-location__expand"
}

import { PropType, ref, computed } from 'vue'
import {
  ServiceLocation,
  LocationPublicTransport,
} from '@/models/location.model'
import { ACCESS_OPTIONS } from '@/enums/services'
import {
  getAccessOptionLabel,
  getPublicTransportTypeLabel,
} from '@/enums/location'
import { TRANSLATION_TYPE } from '@/enums/public'
import { FORMATS, SIZES } from '@/enums/components'
import BaseIcon from '@/components/BaseIcon.vue'
import BaseButton from '@/components/BaseButton.vue'
import GoogleMap from '@/components/GoogleMap.vue'

interface PublicTransportItem extends LocationPublicTransport {
  distance: number
  key: string
  typeTooltip: string
}


import { PUBLIC_TRANSPORT_TYPE } from '@/enums/location'

const accessIcons = {
  is_signposted: 'sign-post',
  is_hard_surfaced_road: 'hard-surfaced-road',
  access_by_tour_bus: 'bus',
  access_by_public_transport: 'public-transport',
  access_by_car: 'car',
  access_on_foot: 'person-simple-walk',
}

const publicTransportIcons = {
  [PUBLIC_TRANSPORT_TYPE.BUS]: 'bus',
  [PUBLIC_TRANSPORT_TYPE.TRAIN]: 'train',
  [PUBLIC_TRANSPORT_TYPE.TRAM]: 'train-regional',
  [PUBLIC_TRANSPORT_TYPE.TROLLEY]: 'bus',
  [PUBLIC_TRANSPORT_TYPE.AIRPORT]: 'airplane-tilt',
  [PUBLIC_TRANSPORT_TYPE.HARBOR]: 'anchor',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceLocationInformation',
  props: {
  modelValue: {
    type: Object as PropType<ServiceLocation>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const LOCATION_COMMENT_LENGTH = 300



const isExpanded = ref<boolean>(false)

const accessPayload = computed(() => {
  const payload = []
  if (props.modelValue) {
    for (const value of Object.values(ACCESS_OPTIONS)) {
      if (props.modelValue[value]) {
        payload.push({
          key: value,
          label: getAccessOptionLabel(value),
        })
      }
    }
  }

  return payload
})

const sortedPublicTransports = computed<PublicTransportItem[]>(() => {
  return props.modelValue.public_transports
    .map((transport, index) => ({
      ...transport,
      distance: Number(transport.distance),
      key: `${transport.type}-${index}-${transport.name}`,
      typeTooltip: getPublicTransportTypeLabel(transport.type),
    }))
    .sort((a, b) => a.distance - b.distance)
})

/** These comments can get quite long so they are cut short in initial unexpanded state */
const isLocationCommentTooLong = computed(() => {
  return !!(props.modelValue.comment.length > LOCATION_COMMENT_LENGTH)
})

/** Whether or not there is any content that should be hidden by default  */
const hasExpandableContent = computed<boolean>(() => {
  // return (
  //   isLocationCommentTooLong.value ||
  //   accessPayload.value.length ||
  //   sortedPublicTransports.value.length
  // )

  // always return true because we have google map hidden that we want to turn visible
  return true
})

/** Location's comment formatted by component's expand logic */
const locationComment = computed<string>(() => {
  if (!isLocationCommentTooLong.value || isExpanded.value) {
    return props.modelValue.comment
  }

  return props.modelValue.comment.slice(0, LOCATION_COMMENT_LENGTH) + '...'
})

return (_ctx: any,_cache: any) => {
  const _component_InfoHelper = _resolveComponent("InfoHelper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('travelingToDestination')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_unref(locationComment))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(locationComment)), 1))
        : _createCommentVNode("", true),
      (__props.modelValue.comment_translation_type === _unref(TRANSLATION_TYPE).MACHINE)
        ? (_openBlock(), _createBlock(BaseIcon, {
            key: 1,
            icon: "google-translate",
            style: {"height":"16px","width":"revert","display":"block"}
          }))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        (_unref(accessPayload).length || _unref(sortedPublicTransports).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(accessPayload).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('access.access')), 1),
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accessPayload), (access) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: access.key,
                          class: "service-location__access"
                        }, [
                          _createVNode(_component_InfoHelper, null, {
                            activator: _withCtx(() => [
                              _createVNode(BaseIcon, {
                                icon: accessIcons[access.key],
                                size: 24
                              }, null, 8, ["icon"])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(access.label), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createTextVNode(" " + _toDisplayString(access.label), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(sortedPublicTransports).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('nearbyTransportStops')), 1),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortedPublicTransports), (transport) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: transport.key,
                          class: "service-location__public-transport"
                        }, [
                          _createVNode(_component_InfoHelper, null, {
                            activator: _withCtx(() => [
                              _createVNode(BaseIcon, {
                                icon: publicTransportIcons[transport.type],
                                size: 24
                              }, null, 8, ["icon"])
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(transport.typeTooltip), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createTextVNode(" " + _toDisplayString(transport.name) + " - " + _toDisplayString(transport.distance) + " km ", 1)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(), _createBlock(GoogleMap, {
            key: `${__props.modelValue.latitude_decimal_degree}-${__props.modelValue.longitude_decimal_degree}`,
            "show-pin": "",
            "hide-coordinates": "",
            class: "service-page__google-map",
            latitude: parseFloat(__props.modelValue.latitude_decimal_degree),
            longitude: parseFloat(__props.modelValue.longitude_decimal_degree)
          }, null, 8, ["latitude", "longitude"]))
        ])
      ], 512), [
        [_vShow, isExpanded.value]
      ]),
      (_unref(hasExpandableContent))
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(BaseButton, {
              label: isExpanded.value ? _ctx.$t('showLess') : _ctx.$t('showMore'),
              format: _unref(FORMATS).TERTIARY,
              size: _unref(SIZES).SMALL,
              icon: isExpanded.value ? 'chevron-up' : 'chevron-down',
              "icon-right": "",
              class: "service-location__expand-button",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => (isExpanded.value = !isExpanded.value), ["prevent"]))
            }, null, 8, ["label", "format", "size", "icon"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})